import * as React from 'react'

type LoadingCandlesProps = {
  className?: string
  label?: string
}

export function LoadingCandles({ className = '', label }: LoadingCandlesProps) {
  // Loader com velas animadas, sem pavios
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <style>{`
        @keyframes candle-rise {
          0% { transform: translateY(8px) scaleY(0.85); opacity: 0.7; }
          50% { transform: translateY(-8px) scaleY(1.05); opacity: 1; }
          100% { transform: translateY(8px) scaleY(0.85); opacity: 0.7; }
        }
      `}</style>
      <div className="relative h-16 w-40">
        {[
          { x: 0,  h: 14, color: '#ff2d55', delay: 0 },
          { x: 24, h: 18, color: '#10b981', delay: 0.08 },
          { x: 48, h: 22, color: '#ff2d55', delay: 0.16 },
          { x: 72, h: 26, color: '#10b981', delay: 0.24 },
          { x: 96, h: 30, color: '#10b981', delay: 0.32 },
        ].map((c, i) => (
          <div key={i} className="absolute bottom-2" style={{ left: c.x }}>
            <div
              style={{
                width: 12,
                height: c.h,
                background: c.color,
                margin: '0 auto',
                borderRadius: 3,
                boxShadow: `0 0 10px ${c.color}44`,
                animation: 'candle-rise 1.2s ease-in-out infinite',
                animationDelay: `${c.delay}s`,
              }}
            />
          </div>
        ))}
      </div>
      <div className="mt-3 text-sm text-foreground/70">{label || 'Carregando...'}</div>
    </div>
  )
}

export default LoadingCandles

